<ng-container *ngIf="inlineEditor else popupEditor">
    <se-numeric-cell-editor-inline tabindex="0"
                                   [value]="value"
                                   [startEdited]="cellStartEdited"
                                   [min]="min"
                                   [max]="max"
                                   [decimal]="decimal"
                                   [separatorInUse]="separatorInUse"
                                   [required]="required"
                                   (formReady)="_onFormReady($event)">
    </se-numeric-cell-editor-inline>
</ng-container>

<ng-template #popupEditor>
    <se-numeric-cell-editor-popup tabindex="0"
                                  [value]="value"
                                  [min]="min"
                                  [max]="max"
                                  [decimal]="decimal"
                                   [separatorInUse]="separatorInUse"
                                  [width]="cellWidth"
                                  [required]="required"
                                  (formReady)="_onFormReady($event)">
    </se-numeric-cell-editor-popup>
</ng-template>

